<template>
  <form class="form" method="post">

    <div id="appClientChoiceVueComponent" class="appFontBlack">
      <br>
      <div id="appClientCardCreate">
        <h2>Encaissement</h2>

        <div class="appCollectionSection">
          <div class="appCollectionSectionDivisions1">
            <p>Nom - Prénom :</p>
            <p>Sexe : </p>
            <p>Notes : </p>
          </div>
          <div class="appCollectionSectionDivisions1">
            <p id="idNameClient">{{ client.firstname }} {{ client.lastname }}</p>
            <p id="sexeClient">{{ client.sexe }}</p>
            <p>{{ client.notes }}</p>
          </div>
        </div>

        <button @click.prevent="historyClient()" type="submit" class="appButtonModel2">Lien historique client</button>

        <div class="appCollectionSection">
          <p class="appCollectionSectionDivisions1">Fiche technique : </p>
          <textarea id="idTechnicalData"></textarea>
        </div>

        <div class="appCollectionButtonSelection">
          <button @click.prevent="show_Prestations()" type="submit" class="appButtonModel3">Prestation<br><img
              class="appHomeLogo" src="../../assets/Icon-Prestations.svg" alt="Logo prestation"></button>
          <button @click.prevent="show_Produits()" type="submit" class="appButtonModel3">Produits<br><img
              class="appHomeLogo" src="../../assets/Icon-Products.svg" alt="Logo produits"></button>
          <button @click.prevent="show_Reductions()" type="submit" class="appButtonModel3">Réduction<br><img
              class="appHomeLogo" src="../../assets/Icon-Reduction.svg" alt="Logo réduction"></button>
          <button @click.prevent="show_Writing()" type="submit" class="appButtonModel3">Montant libre<br><img
              class="appHomeLogo" src="../../assets/Icon-Pen.svg" alt="Logo stylo"></button>
        </div>

        <div id="appCollectionDivPrestations">
          <div class="appCollectionSection2">
            <h3>Prestations</h3>
            <div class="appCollectionSectionDivisions2">
              <div class="appCollectionSectionDivisions2-1">
                <p class="appCollectionSectionDivisionTarifsTitle">Tarif Femmes</p>
                <div :key="'tarifFiltersWomen' + index" v-for="(tarifFiltersWomen, index) in tarifFiltersWomens"
                  class="appCollectionSectionDivisionTarifsMain">
                  <p v-if="tarifFiltersWomen.priceUnique + tarifFiltersWomen.priceS + tarifFiltersWomen.priceM + tarifFiltersWomen.priceL + tarifFiltersWomen.priceXL > '0'"
                    class="appLabelStyle1">{{ tarifFiltersWomen.name }}</p>
                  <div class="appCollectionSectionDivisionTarifsBlocs">
                    <button v-if="tarifFiltersWomen.priceUnique > '0'"
                      @click.prevent="addTarifPanier(tarifFiltersWomen._id)" type="submit"
                      class="appCollectionSectionDivisionButton1">-</button>
                    <button v-if="tarifFiltersWomen.priceS > '0'" @click.prevent="addTarifPanier(tarifFiltersWomen._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">S</button>
                    <button v-if="tarifFiltersWomen.priceM > '0'" @click.prevent="addTarifPanier(tarifFiltersWomen._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">M</button>
                    <button v-if="tarifFiltersWomen.priceL > '0'" @click.prevent="addTarifPanier(tarifFiltersWomen._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">L</button>
                    <button v-if="tarifFiltersWomen.priceXL > '0'" @click.prevent="addTarifPanier(tarifFiltersWomen._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">XL</button>
                  </div>
                </div>

                <p class="appCollectionSectionDivisionTarifsTitle">Suppléments</p>
                <div :key="'tarifFiltersSupplements' + index" v-for="(tarifFiltersSupplements, index) in tarifFiltersSupplements"
                  class="appCollectionSectionDivisionTarifsMain">
                  <p v-if="tarifFiltersSupplements.priceUnique + tarifFiltersSupplements.priceS + tarifFiltersSupplements.priceM + tarifFiltersSupplements.priceL + tarifFiltersSupplements.priceXL > '0'"
                    class="appLabelStyle1">{{ tarifFiltersSupplements.name }}</p>
                  <div class="appCollectionSectionDivisionTarifsBlocs">
                    <button v-if="tarifFiltersSupplements.priceUnique > '0'"
                      @click.prevent="addTarifPanier(tarifFiltersSupplements._id)" type="submit"
                      class="appCollectionSectionDivisionButton1">-</button>
                    <button v-if="tarifFiltersSupplements.priceS > '0'" @click.prevent="addTarifPanier(tarifFiltersSupplements._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">S</button>
                    <button v-if="tarifFiltersSupplements.priceM > '0'" @click.prevent="addTarifPanier(tarifFiltersSupplements._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">M</button>
                    <button v-if="tarifFiltersSupplements.priceL > '0'" @click.prevent="addTarifPanier(tarifFiltersSupplements._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">L</button>
                    <button v-if="tarifFiltersSupplements.priceXL > '0'" @click.prevent="addTarifPanier(tarifFiltersSupplements._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">XL</button>
                  </div>
                </div>

                <p class="appCollectionSectionDivisionTarifsTitle">Tarif Hommes</p>
                <div :key="'tarifFiltersMen' + index" v-for="(tarifFiltersMen, index) in tarifFiltersMens"
                  class="appCollectionSectionDivisionTarifsMain">
                  <p v-if="tarifFiltersMen.priceUnique > '0'" class="appLabelStyle1">{{ tarifFiltersMen.name }}</p>
                  <div class="appCollectionSectionDivisionTarifsBlocs">
                    <button v-if="tarifFiltersMen.priceUnique > '0'" @click.prevent="addTarifPanier(tarifFiltersMen._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">-</button>
                  </div>
                </div>

                <p class="appCollectionSectionDivisionTarifsTitle">Tarif Enfants</p>
                <div :key="'tarifFiltersKids' + index" v-for="(tarifFiltersKids, index) in tarifFiltersKids"
                  class="appCollectionSectionDivisionTarifsMain">
                  <p v-if="tarifFiltersKids.priceUnique + tarifFiltersKids.priceS + tarifFiltersKids.priceM + tarifFiltersKids.priceL > '0'" class="appLabelStyle1">{{ tarifFiltersKids.name }}</p>
                   <div class="appCollectionSectionDivisionTarifsBlocs">
                    <button v-if="tarifFiltersKids.priceUnique > '0'" @click.prevent="addTarifPanier(tarifFiltersKids._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">-</button>
                      <button v-if="tarifFiltersKids.priceS > '0'" @click.prevent="addTarifPanier(tarifFiltersKids._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">0-5</button>
                      <button v-if="tarifFiltersKids.priceM > '0'" @click.prevent="addTarifPanier(tarifFiltersKids._id)"
                      type="submit" class="appCollectionSectionDivisionButton1"></button>
                      <button v-if="tarifFiltersKids.priceL > '0'" @click.prevent="addTarifPanier(tarifFiltersKids._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">6-17</button>
                  </div>
                </div>

                <p class="appCollectionSectionDivisionTarifsTitle">Cérémonie</p>
                <div :key="'tarifFiltersCeremonie' + index" v-for="(tarifFiltersCeremonie, index) in tarifFiltersCeremonie"
                  class="appCollectionSectionDivisionTarifsMain">
                  <p v-if="tarifFiltersCeremonie.priceUnique + tarifFiltersCeremonie.priceS + tarifFiltersCeremonie.priceM + tarifFiltersCeremonie.priceL + tarifFiltersCeremonie.priceXL > '0'"
                    class="appLabelStyle1">{{ tarifFiltersCeremonie.name }}</p>
                  <div class="appCollectionSectionDivisionTarifsBlocs">
                    <button v-if="tarifFiltersCeremonie.priceUnique > '0'"
                      @click.prevent="addTarifPanier(tarifFiltersCeremonie._id)" type="submit"
                      class="appCollectionSectionDivisionButton1">-</button>
                    <button v-if="tarifFiltersCeremonie.priceS > '0'" @click.prevent="addTarifPanier(tarifFiltersCeremonie._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">S</button>
                    <button v-if="tarifFiltersCeremonie.priceM > '0'" @click.prevent="addTarifPanier(tarifFiltersCeremonie._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">M</button>
                    <button v-if="tarifFiltersCeremonie.priceL > '0'" @click.prevent="addTarifPanier(tarifFiltersCeremonie._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">L</button>
                    <button v-if="tarifFiltersCeremonie.priceXL > '0'" @click.prevent="addTarifPanier(tarifFiltersCeremonie._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">XL</button>
                  </div>
                </div>

                <p class="appCollectionSectionDivisionTarifsTitle">Trichotherapy</p>
                <div :key="'tarifFiltersSoins' + index" v-for="(tarifFiltersSoins, index) in tarifFiltersSoins"
                  class="appCollectionSectionDivisionTarifsMain">
                  <p v-if="tarifFiltersSoins.priceUnique > '0'" class="appLabelStyle1">{{ tarifFiltersSoins.name }}</p>
                  <div class="appCollectionSectionDivisionTarifsBlocs">
                    <button v-if="tarifFiltersSoins.priceUnique > '0'" @click.prevent="addTarifPanier(tarifFiltersSoins._id)"
                      type="submit" class="appCollectionSectionDivisionButton1">-</button>
                  </div>
                </div>

              </div>
            </div>
            <button @click.prevent="unshow_Prestations()" type="submit" class="appButtonModel3">^</button>
          </div>
        </div>

        <div id="appCollectionDivProduits">
          <div class="appCollectionSection2">
            <h3>Vente produits</h3>
            <div class="appCollectionSectionDivisions2">
              <div class="appCollectionSectionDivisions2-1">
                <input type="text" v-model="search" class="appSearchBar" placeholder="Rechercher">
                <div :key="index" @click.prevent="addProductPanier(product._id)"
                  v-for="(product, index) in filteredProducts" class="appProductCardList appHoverEffect">
                  <div class="appProductCardListLine1">
                    <p>{{ product.marque.toUpperCase() }} {{ product.name }}</p>
                    <p>Qté : {{ product.quantity }}</p>
                  </div>
                  <div class="appProductCardListLine2">
                    <p>{{ product.category }}</p>
                    <p>{{ product.priceSeller }} €</p>
                  </div>
                </div>
              </div>
            </div>
            <button @click.prevent="unshow_Produits()" type="submit" class="appButtonModel3">^</button>
          </div>
        </div>

        <div id="appCollectionDivReductions">
          <div class="appCollectionSection2">
            <h3>Remise</h3>
            <div class="appCollectionSectionDivisions2">
              <div class="appCollectionSectionDivisions2-1">
                <p class="appLabelStyle3">Montant - €</p>
              </div>
              <div class="appCollectionSectionDivisions2-2">
                <input class="appInputStyle1" id="remisePrice" type="number" step="0.01">
                <br>
              </div>
            </div>
            <button @click.prevent="addRemisePanier()" type="submit" class="appButtonModel3">Valider</button>

            <div class="appCollectionSectionDivisions2-1">
                <p class="appLabelStyle3"> Remise sur forfaits - €</p>
              <div class="appCollectionButtonSelection">
                <button @click.prevent="addRemisePanierShampoing()" type="submit" class="appButtonModel3">Remise Shampoing</button>
                <button @click.prevent="addRemisePanierCoupe()" type="submit" class="appButtonModel3">Remise Coupe</button>
              </div>
            </div>

            <br>
            <h3>Réductions (pourcentage)</h3>
            <div class="appCollectionButtonSelection">
              <button @click.prevent="addReductionPanier(0.00)" type="submit" class="appButtonModel3">0%</button>
              <button @click.prevent="addReductionPanier(0.05)" type="submit" class="appButtonModel3">5%</button>
              <button @click.prevent="addReductionPanier(0.10)" type="submit" class="appButtonModel3">10%</button>
              <button @click.prevent="addReductionPanier(0.15)" type="submit" class="appButtonModel3">15%</button>
              <button @click.prevent="addReductionPanier(0.20)" type="submit" class="appButtonModel3">20%</button>
              <div>
              </div>
            </div>
            <button @click.prevent="unshow_Reductions()" type="submit" class="appButtonModel3">^</button>
          </div>
        </div>

        <div id="appCollectionDivWriting">
          <div class="appCollectionSection2">
            <h3>Saisie libre</h3>
            <div class="appCollectionSectionDivisions2">
              <div class="appCollectionSectionDivisions2-1">
                <p class="appLabelStyle3">Descriptif</p>
                <p class="appLabelStyle3">Montant - €</p>
              </div>
              <div class="appCollectionSectionDivisions2-2">
                <input class="appInputStyle1" id="textWritingName">
                <input class="appInputStyle1" id="textWritingValue" type="number" step="0.01">
              </div>
            </div>
            <button @click.prevent="addTextAndPricePanier()" type="submit" class="appButtonModel3">Valider</button>
            <br>
            <br>
            <button @click.prevent="unshow_Writing()" type="submit" class="appButtonModel3">^</button>
          </div>
        </div>

        <br>
        <h2>Liste de l'encaissement en cours</h2>

        <div class="appCollectionPanier">
          <div class="appCollectionPanierTitle">
            <p class="appCollectionWidth4">Qté</p>
            <p class="appCollectionWidth2">Catégorie</p>
            <p class="appCollectionWidth2">Sexe</p>
            <p class="appCollectionWidth2">Taille</p>
            <p class="appCollectionWidth4">Désignation</p>
            <p class="appCollectionWidth2">Prix</p>
            <p class="appCollectionWidth2">Total</p>
            <p class="appCollectionWidth2">Suppr.</p>
          </div>
          <div id="listOfItems"></div>
        </div>

        <div class="appCollectionSection">
          <div class="appCollectionSectionDivisions1">
            <p>Prestations :</p>
            <p>Prestations (€) :</p>
            <p>Ventes :</p>
            <p>Ventes (€) :</p>
            <p>Remise (€) :</p>
            <br>
            <p>Avant réduction :</p>
            <p>Base réduction :</p>
            <p>Réduction (%) :</p>
            <p>Réduction (€) :</p>
            <br>
            <p class="appCollectionWidthBold appCollectionTotalAspect">Total HT à régler :</p>
          </div>
          <div class="appCollectionSectionDivisions1">
            <p id="totalNbPrestations">0</p>
            <p id="totalCostPrestations">0</p>
            <p id="totalNbProducts">0</p>
            <p id="totalCostProducts">0</p>
            <p id="totalRemise">0</p>
          <br>
          <p id="totalBeforeReduction">0</p>
          <p id="totalAmountforReduction">0</p>
          <p id="totalReductionPourcent">0</p>
          <p id="totalReductionCost">0</p>
          <br>
          <p class="appCollectionWidthBold appCollectionTotalAspect" id="totalCostsOfPanier">0</p>
        </div>
      </div>
    </div>
    <button @click.prevent="createCollection()" type="submit" class="appButtonModel2">Valider mon encaissement</button>
    <button @click.prevent="deleteCollection()" type="submit" class="appButtonModel2">Supprimer mon encaissement</button>
    <button @click.prevent="createEstimate()" type="submit" class="appButtonModel2">Afficher en devis (après validation)</button>
  </div>

</form></template>

<script>
import axios from 'axios'
import moment from 'moment'
import VueNumeric from 'vue-numeric'
import logoSVG from '../../assets/Icon-Delete.svg'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    VueNumeric
  },
  name: 'SlotMainMenu',
  data () {
    return {
      client: '',
      tarif: [],
      product: '',
      search: ''
    }
  },
  computed: {
    tarifFiltersWomens () {
      return this.tarif.filter(tarif => tarif.category === 'FEMMES')
    },
    tarifFiltersSupplements () {
      return this.tarif.filter(tarif => tarif.category === 'SUPPLÉMENTS')
    },
    tarifFiltersCeremonie () {
      return this.tarif.filter(tarif => tarif.category === 'CÉRÉMONIE')
    },
    tarifFiltersMens () {
      return this.tarif.filter(tarif => tarif.category === 'HOMMES')
    },
    tarifFiltersKids () {
      return this.tarif.filter(tarif => tarif.category === 'ENFANTS')
    },
    tarifFiltersSoins () {
      return this.tarif.filter(tarif => tarif.category === 'SOINS')
    },
    filteredProducts () {
      if (this.product.length > 0) {
        return this.product.filter(product => {
          return product.marque.toLowerCase().includes(this.search.toLowerCase()) ||
          product.name.toLowerCase().includes(this.search.toLowerCase()) ||
          product.category.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    }
  },
  updated () {
    this.showPanier()
  },
  mounted () {
    if (localStorage.getItem('orderPrivilegiaSettings') !== null) {
      document.getElementById('idTechnicalData').innerText = JSON.parse(localStorage.getItem('orderPrivilegiaSettings'))[0].technicalData
      document.getElementById('totalReductionPourcent').innerText = JSON.parse(localStorage.getItem('orderPrivilegiaSettings'))[0].reduction + '%'
    }
    const url = document.location.href
    const idToModify = url.substring(url.lastIndexOf('=') + 1)
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    axios
      .get(('https://privilegia.fr/api/clients/' + idToModify), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
      .then((response) => {
        this.client = response.data
        // this.listClient()
        this.listTarifs()
        this.listProducts()
      })
  },
  methods: {
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    show_Prestations () {
      document.getElementById('appCollectionDivPrestations').style.display = 'inline'
      document.getElementById('appCollectionDivProduits').style.display = 'none'
      document.getElementById('appCollectionDivReductions').style.display = 'none'
      document.getElementById('appCollectionDivWriting').style.display = 'none'
    },
    unshow_Prestations () {
      document.getElementById('appCollectionDivPrestations').style.display = 'none'
    },
    show_Produits () {
      document.getElementById('appCollectionDivPrestations').style.display = 'none'
      document.getElementById('appCollectionDivProduits').style.display = 'inline'
      document.getElementById('appCollectionDivReductions').style.display = 'none'
      document.getElementById('appCollectionDivWriting').style.display = 'none'
    },
    unshow_Produits () {
      document.getElementById('appCollectionDivProduits').style.display = 'none'
    },
    show_Reductions () {
      document.getElementById('appCollectionDivPrestations').style.display = 'none'
      document.getElementById('appCollectionDivProduits').style.display = 'none'
      document.getElementById('appCollectionDivReductions').style.display = 'inline'
      document.getElementById('appCollectionDivWriting').style.display = 'none'
    },
    unshow_Reductions () {
      document.getElementById('appCollectionDivReductions').style.display = 'none'
    },
    show_Writing () {
      document.getElementById('appCollectionDivPrestations').style.display = 'none'
      document.getElementById('appCollectionDivProduits').style.display = 'none'
      document.getElementById('appCollectionDivReductions').style.display = 'none'
      document.getElementById('appCollectionDivWriting').style.display = 'inline'
    },
    unshow_Writing () {
      document.getElementById('appCollectionDivWriting').style.display = 'none'
    },
    listClient () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/clients'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.client = response.data
        })
    },
    listTarifs () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/tarifs'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.tarif = response.data.sort(function tri (a, b) {
            if (a.name < b.name) { return -1 }
            if (a.name === b.name) { return 0 }
            if (a.name > b.name) { return 1 }
          })
        })
    },
    listProducts () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/produits'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.product = response.data.sort(function tri (a, b) {
            if (a.marque < b.marque) { return -1 }
            if (a.marque === b.marque) { return 0 }
            if (a.marque > b.marque) { return 1 }
          })
          this.product = this.product.filter(product => product.priceSeller > 0)
        })
    },
    historyClient () {
      this.$router.push('/App/Clients/Historique?id=' + this.client._id)
    },
    async addTarifPanier (idPrestation) {
      const nameOfButton = event.target.innerHTML
      try {
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        await axios
          .get(('https://privilegia.fr/api/tarifs/' + idPrestation), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
          .then((response) => {
            this.tarif = response.data
          })
      } catch (error) { console.log(error) }
      let priceToApply = 0
      if (nameOfButton === '-') { priceToApply = parseFloat(this.tarif.priceUnique) }
      if (nameOfButton === 'S') { priceToApply = parseFloat(this.tarif.priceS) }
      if (nameOfButton === 'M') { priceToApply = parseFloat(this.tarif.priceM) }
      if (nameOfButton === 'L') { priceToApply = parseFloat(this.tarif.priceL) }
      if (nameOfButton === 'XL') { priceToApply = parseFloat(this.tarif.priceXL) }
      if (nameOfButton === '0-5') { priceToApply = parseFloat(this.tarif.priceS) }
      if (nameOfButton === '6-17') { priceToApply = parseFloat(this.tarif.priceL) }
      // Si localStorage n'existe pas
      let mySelection = []
      if (localStorage.getItem('orderPrivilegia') === null) {
        const cartPrestation =
        {
          category: 'Prestation',
          sexe: this.tarif.category.slice(0, -1).toLowerCase(),
          size: nameOfButton,
          designation: this.tarif.name,
          quantity: 1,
          price: priceToApply,
          total: priceToApply,
          codeID: this.tarif._id
        }
        mySelection.push(cartPrestation)
        localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
        this.unshow_Prestations()
        this.showPanier()
      } else {
      // Si localStorage existe
        mySelection = JSON.parse(localStorage.getItem('orderPrivilegia'))
        // Si doublon
        const findPrestation = mySelection.find(element => element.category === 'Prestation' && element.designation === this.tarif.name && element.size === nameOfButton)
        const findIndexPrestation = mySelection.findIndex(element => element.category === 'Prestation' && element.designation === this.tarif.name && element.size === nameOfButton)
        if (findPrestation) {
          var newQuantity = mySelection[findIndexPrestation].quantity + 1
          mySelection.splice(findIndexPrestation, 1)
          const cartPrestation =
        {
          category: 'Prestation',
          sexe: this.tarif.category.slice(0, -1).toLowerCase(),
          size: nameOfButton,
          designation: this.tarif.name,
          quantity: newQuantity,
          price: priceToApply,
          total: priceToApply * newQuantity,
          codeID: this.tarif._id
        }
          mySelection.push(cartPrestation)
          localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
          this.unshow_Prestations()
          this.showPanier()
        } else {
        // Si pas de doublon
          const cartPrestation =
        {
          category: 'Prestation',
          sexe: this.tarif.category.slice(0, -1).toLowerCase(),
          size: nameOfButton,
          designation: this.tarif.name,
          quantity: 1,
          price: priceToApply,
          total: priceToApply,
          codeID: this.tarif._id
        }
          mySelection.push(cartPrestation)
          localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
          this.unshow_Prestations()
          this.showPanier()
        }
      }
    },
    async addProductPanier (idProduct) {
      try {
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        await axios
          .get(('https://privilegia.fr/api/produits/' + idProduct), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
          .then((response) => {
            this.tarif = response.data
          })
      } catch (error) { console.log(error) }
      // Si localStorage n'existe pas
      let mySelection = []
      if (localStorage.getItem('orderPrivilegia') === null) {
        const cartProduct =
        {
          category: 'Vente',
          sexe: '-',
          size: '-',
          designation: this.tarif.marque + ' ' + this.tarif.name,
          quantity: 1,
          price: this.tarif.priceSeller,
          total: this.tarif.priceSeller,
          codeID: this.tarif._id
        }
        mySelection.push(cartProduct)
        localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
        this.unshow_Produits()
        this.showPanier()
      } else {
      // Si localStorage existe
        mySelection = JSON.parse(localStorage.getItem('orderPrivilegia'))
        // Si doublon
        const findProduct = mySelection.find(element => element.category === 'Vente' && element.designation === this.tarif.marque + ' ' + this.tarif.name)
        const findIndexProduct = mySelection.findIndex(element => element.category === 'Vente' && element.designation === this.tarif.marque + ' ' + this.tarif.name)
        if (findProduct) {
          var newQuantity = mySelection[findIndexProduct].quantity + 1
          mySelection.splice(findIndexProduct, 1)
          const cartProduct =
        {
          category: 'Vente',
          sexe: '-',
          size: '-',
          designation: this.tarif.marque + ' ' + this.tarif.name,
          quantity: newQuantity,
          price: this.tarif.priceSeller,
          total: this.tarif.priceSeller * newQuantity,
          codeID: this.tarif._id
        }
          mySelection.push(cartProduct)
          localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
          this.unshow_Produits()
          this.showPanier()
        } else {
        // Si pas de doublon
          const cartProduct =
        {
          category: 'Vente',
          sexe: '-',
          size: '-',
          designation: this.tarif.marque + ' ' + this.tarif.name,
          quantity: 1,
          price: this.tarif.priceSeller,
          total: this.tarif.priceSeller,
          codeID: this.tarif._id
        }
          mySelection.push(cartProduct)
          localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
          this.unshow_Produits()
          this.showPanier()
        }
      }
    },
    addRemisePanier () {
      // Si localStorage n'existe pas
      let mySelection = []
      if (localStorage.getItem('orderPrivilegia') === null) {
        const cartRemise =
        {
          category: 'Remise',
          sexe: '-',
          size: '-',
          designation: 'Remise',
          quantity: 1,
          price: -document.getElementById('remisePrice').value,
          total: -document.getElementById('remisePrice').value
        }
        mySelection.push(cartRemise)
        localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
        this.unshow_Reductions()
        this.showPanier()
      } else {
      // Si localStorage existe
        mySelection = JSON.parse(localStorage.getItem('orderPrivilegia'))
        const cartRemise =
        {
          category: 'Remise',
          sexe: '-',
          size: '-',
          designation: 'Remise',
          quantity: 1,
          price: -document.getElementById('remisePrice').value,
          total: -document.getElementById('remisePrice').value
        }
        mySelection.push(cartRemise)
        localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
        this.unshow_Reductions()
        this.showPanier()
      }
    },
    addRemisePanierShampoing () {
      // Si localStorage n'existe pas
      let mySelection = []
      if (localStorage.getItem('orderPrivilegia') === null) {
        const cartRemise =
        {
          category: 'Remise',
          sexe: '-',
          size: '-',
          designation: 'Remise Shampoing',
          quantity: 1,
          price: -3,
          total: -3
        }
        mySelection.push(cartRemise)
        localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
        this.unshow_Reductions()
        this.showPanier()
      } else {
      // Si localStorage existe
        mySelection = JSON.parse(localStorage.getItem('orderPrivilegia'))
        // Si pas de doublon
        const cartRemise =
        {
          category: 'Remise',
          sexe: '-',
          size: '-',
          designation: 'Remise Shampoing',
          quantity: 1,
          price: -3,
          total: -3
        }
        mySelection.push(cartRemise)
        localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
        this.unshow_Reductions()
        this.showPanier()
      }
    },
    addRemisePanierCoupe () {
      // Si localStorage n'existe pas
      let mySelection = []
      if (localStorage.getItem('orderPrivilegia') === null) {
        const cartRemise =
        {
          category: 'Remise',
          sexe: '-',
          size: '-',
          designation: 'Remise Coupe',
          quantity: 1,
          price: -10,
          total: -10
        }
        mySelection.push(cartRemise)
        localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
        this.unshow_Reductions()
        this.showPanier()
      } else {
      // Si localStorage existe
        mySelection = JSON.parse(localStorage.getItem('orderPrivilegia'))
        const cartRemise =
        {
          category: 'Remise',
          sexe: '-',
          size: '-',
          designation: 'Remise Coupe',
          quantity: 1,
          price: -10,
          total: -10
        }
        mySelection.push(cartRemise)
        localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
        this.unshow_Reductions()
        this.showPanier()
      }
    },
    addReductionPanier (value) {
      document.getElementById('totalReductionPourcent').innerText = value * 100 + '%'
      this.unshow_Reductions()
      this.showPanier()
    },
    addTextAndPricePanier () {
    // Si localStorage n'existe pas
      let mySelection = []
      if (localStorage.getItem('orderPrivilegia') === null) {
        const cartTextWriting =
        {
          category: 'Prestation',
          sexe: '-',
          size: '-',
          designation: document.getElementById('textWritingName').value,
          quantity: 1,
          price: document.getElementById('textWritingValue').value,
          total: document.getElementById('textWritingValue').value
        }
        mySelection.push(cartTextWriting)
        localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
        this.unshow_Writing()
        this.showPanier()
      } else {
      // Si localStorage existe
        mySelection = JSON.parse(localStorage.getItem('orderPrivilegia'))
        // Si doublon
        const findWriting = mySelection.find(element => element.category === 'Prestation' && element.designation === document.getElementById('textWritingName').value)
        const findIndexWriting = mySelection.findIndex(element => element.category === 'Prestation' && element.designation === document.getElementById('textWritingName').value)
        if (findWriting) {
          var newQuantity = mySelection[findIndexWriting].quantity + 1
          mySelection.splice(findIndexWriting, 1)
          const cartTextWriting =
        {
          category: 'Prestation',
          sexe: '-',
          size: '-',
          designation: document.getElementById('textWritingName').value,
          quantity: newQuantity,
          price: document.getElementById('textWritingValue').value,
          total: document.getElementById('textWritingValue').value * newQuantity
        }
          mySelection.push(cartTextWriting)
          localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
          this.unshow_Writing()
          this.showPanier()
        } else {
        // Si pas de doublon
          const cartTextWriting =
        {
          category: 'Prestation',
          sexe: '-',
          size: '-',
          designation: document.getElementById('textWritingName').value,
          quantity: 1,
          price: document.getElementById('textWritingValue').value,
          total: document.getElementById('textWritingValue').value
        }
          mySelection.push(cartTextWriting)
          localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
          this.unshow_Writing()
          this.showPanier()
        }
      }
    },
    showPanier () {
      if (localStorage.getItem('orderPrivilegia') === null) {
        return
      }
      // Effacer valeurs
      let listToRemove = document.getElementById('listOfItems')
      if (listToRemove != null) {
        while (listToRemove.firstChild) {
          listToRemove.removeChild(listToRemove.firstChild)
        }
      }
      // Regénérer les valeurs
      var myTotalCounter = JSON.parse(localStorage.getItem('orderPrivilegia')).length
      var totalNbPrestations = 0
      var totalCostPrestations = 0
      var totalNbProducts = 0
      var totalCostProducts = 0
      var totalRemise = 0
      var totalBeforeReduction = 0
      var totalAmountforReduction = 0
      for (let myCounter = 0; myCounter < myTotalCounter; myCounter++) {
        var myLocalStorage = localStorage.getItem('orderPrivilegia')
        var myLocalStorageJSON = JSON.parse(myLocalStorage)
        const textCategory = myLocalStorageJSON[myCounter].category
        const textSexe = myLocalStorageJSON[myCounter].sexe
        const textSize = myLocalStorageJSON[myCounter].size
        const textDesignation = myLocalStorageJSON[myCounter].designation
        const textQuantity = myLocalStorageJSON[myCounter].quantity
        const textPrice = myLocalStorageJSON[myCounter].price
        const textTotal = myLocalStorageJSON[myCounter].total
        // Créer carte
        // Créer le div de l'item
        let newDivItem = document.createElement('div')
        newDivItem.className = 'appCollectionPanierItems'
        // Créer les classes
        let newPCategory = document.createElement('p')
        newPCategory.className = 'appCollectionWidth4'
        newPCategory.innerText = textCategory
        let newPSexe = document.createElement('p')
        newPSexe.className = 'appCollectionWidth2'
        newPSexe.innerText = textSexe
        let newPSize = document.createElement('p')
        newPSize.className = 'appCollectionWidth2'
        newPSize.innerText = textSize
        let newPDesignation = document.createElement('p')
        newPDesignation.className = 'appCollectionWidth3'
        newPDesignation.innerText = textDesignation
        // Créer le prix unitaire avec mise en forme
        let newPPrice = document.createElement('p')
        newPPrice.className = 'appCollectionWidth2'
        const currencyPrice = function (textTotal) {
          return new Intl.NumberFormat('FR-fr', {style: 'currency', currency: 'EUR', minimumFractionDigits: 2}).format(textTotal).replace('€', '')
        }
        const textPriceCurrency = currencyPrice(textPrice)
        newPPrice.innerText = textPriceCurrency
        // Créer le prix total avec mise en forme
        let newPTotal = document.createElement('p')
        newPTotal.className = 'appCollectionPanierItems appCollectionWidthBold'
        const currencyTotal = function (textTotal) {
          return new Intl.NumberFormat('FR-fr', {style: 'currency', currency: 'EUR', minimumFractionDigits: 2}).format(textTotal)
        }
        const textTotalCurrency = currencyTotal(textTotal)
        newPTotal.innerText = textTotalCurrency
        // Créer l'image
        let newPImage = document.createElement('p')
        newPImage.className = 'appCollectionWidth2 appHoverEffect'
        let newLogo = document.createElement('img')
        newLogo.src = logoSVG
        newLogo.alt = 'Logo supprimer'
        newLogo.className = 'appHomeLogo'
        newLogo.addEventListener('click', eventDeleteItem => {
          if (confirm('Supprimer cette ligne ?')) {
            let mySelection = JSON.parse(window.localStorage.getItem('orderPrivilegia'))
            mySelection.splice(myCounter, 1)
            localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
            this.showPanier()
          }
        })
        // Créer l'input +/-
        let newDivQuantity = document.createElement('div')
        newDivQuantity.className = 'appCollectionQuantityToggle'
        let newDivQuantityButtonDecrement = document.createElement('button')
        newDivQuantityButtonDecrement.innerText = '-'
        newDivQuantityButtonDecrement.addEventListener('click', eventReduceOne => {
          let mySelection = JSON.parse(localStorage.getItem('orderPrivilegia'))
          const findDataToChange = mySelection.find(element => element.category === textCategory && element.designation === textDesignation && element.size === textSize)
          const findIndexDataToChange = mySelection.findIndex(element => element.category === textCategory && element.designation === textDesignation && element.size === textSize)
          if (findDataToChange.quantity > 1) {
            var newQuantityAfterAdding = findDataToChange.quantity - 1
            const cartDecresase =
            {
              category: findDataToChange.category,
              sexe: findDataToChange.sexe,
              size: findDataToChange.size,
              designation: findDataToChange.designation,
              quantity: newQuantityAfterAdding,
              price: findDataToChange.price,
              total: findDataToChange.price * newQuantityAfterAdding,
              codeID: findDataToChange.codeID
            }
            mySelection.splice(findIndexDataToChange, 1, cartDecresase)
            localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
            this.showPanier()
          } else {
            this.showPanier()
          }
        }
        )
        let newQuantityInput = document.createElement('input')
        newQuantityInput.type = 'text'
        newQuantityInput.value = textQuantity
        let newDivQuantityButtonIncrement = document.createElement('button')
        newDivQuantityButtonIncrement.innerText = '+'
        newDivQuantityButtonIncrement.addEventListener('click', eventAddOne => {
          let mySelection = JSON.parse(localStorage.getItem('orderPrivilegia'))
          const findDataToChange = mySelection.find(element => element.category === textCategory && element.designation === textDesignation && element.size === textSize)
          const findIndexDataToChange = mySelection.findIndex(element => element.category === textCategory && element.designation === textDesignation && element.size === textSize)
          var newQuantityAfterAdding = findDataToChange.quantity + 1
          const cartIncrease =
            {
              category: findDataToChange.category,
              sexe: findDataToChange.sexe,
              size: findDataToChange.size,
              designation: findDataToChange.designation,
              quantity: newQuantityAfterAdding,
              price: findDataToChange.price,
              total: findDataToChange.price * newQuantityAfterAdding,
              codeID: findDataToChange.codeID
            }
          mySelection.splice(findIndexDataToChange, 1, cartIncrease)
          localStorage.setItem('orderPrivilegia', JSON.stringify(mySelection))
          this.showPanier()
        }
        )
        // Intégrer dans le HTML
        document.getElementById('listOfItems').appendChild(newDivItem)
        newDivItem.appendChild(newDivQuantity)
        newDivQuantity.appendChild(newDivQuantityButtonDecrement)
        newDivQuantity.appendChild(newQuantityInput)
        newDivQuantity.appendChild(newDivQuantityButtonIncrement)
        newDivItem.appendChild(newPCategory)
        newDivItem.appendChild(newPSexe)
        newDivItem.appendChild(newPSize)
        newDivItem.appendChild(newPDesignation)
        newDivItem.appendChild(newPPrice)
        newDivItem.appendChild(newPTotal)
        newDivItem.appendChild(newPImage)
        newPImage.appendChild(newLogo)
        // Actualiser valeurs de l'encart "Total"
        if (myLocalStorageJSON[myCounter].category === 'Prestation') {
          totalNbPrestations = totalNbPrestations + myLocalStorageJSON[myCounter].quantity
          document.getElementById('totalNbPrestations').innerText = totalNbPrestations
        }
        if (myLocalStorageJSON[myCounter].category === 'Prestation') {
          totalCostPrestations = totalCostPrestations + myLocalStorageJSON[myCounter].total
          document.getElementById('totalCostPrestations').innerText = Number(totalCostPrestations).toFixed(2) + ' €'
        }
        if (myLocalStorageJSON[myCounter].category === 'Vente') {
          totalNbProducts = totalNbProducts + myLocalStorageJSON[myCounter].quantity
          document.getElementById('totalNbProducts').innerText = totalNbProducts
        }
        if (myLocalStorageJSON[myCounter].category === 'Vente') {
          totalCostProducts = totalCostProducts + myLocalStorageJSON[myCounter].total
          document.getElementById('totalCostProducts').innerText = Number(totalCostProducts).toFixed(2) + ' €'
        }
        if (myLocalStorageJSON[myCounter].category === 'Remise') {
          totalRemise = totalRemise + myLocalStorageJSON[myCounter].total
          document.getElementById('totalRemise').innerText = totalRemise + ' €'
        }
        if (myLocalStorageJSON[myCounter].category === 'Prestation' && myLocalStorageJSON[myCounter].sexe !== 'enfant') {
          totalAmountforReduction = totalAmountforReduction + myLocalStorageJSON[myCounter].total
          document.getElementById('totalAmountforReduction').innerText = Number(totalAmountforReduction).toFixed(2) + ' €'
        }
        totalBeforeReduction = totalCostPrestations + totalCostProducts + totalRemise
        document.getElementById('totalBeforeReduction').innerText = Number(totalBeforeReduction).toFixed(2) + ' €'
      }
      let reductionData = parseInt(document.getElementById('totalReductionPourcent').outerText)
      if (reductionData === 0) {
        document.getElementById('totalReductionPourcent').innerText = 0
        document.getElementById('totalReductionCost').innerText = 0 + ' €'
        document.getElementById('totalCostsOfPanier').innerText = Number(totalBeforeReduction).toFixed(2) + ' €'
      } else {
        let reduction = reductionData / 100
        var totalReductionCost = (totalAmountforReduction * reduction)
        document.getElementById('totalReductionCost').innerText = Number(totalReductionCost).toFixed(2) + ' €'
        var totalCostsOfPanier = totalBeforeReduction - totalReductionCost
        document.getElementById('totalCostsOfPanier').innerText = Number(totalCostsOfPanier).toFixed(2) + ' €'
      }
      // Rectifier si valeur à 0
      if (totalNbPrestations === 0) {
        document.getElementById('totalNbPrestations').innerText = totalNbPrestations
        document.getElementById('totalCostPrestations').innerText = Number(totalCostPrestations).toFixed(2) + ' €'
      }
      if (totalNbProducts === 0) {
        document.getElementById('totalNbProducts').innerText = totalNbProducts
        document.getElementById('totalCostProducts').innerText = Number(totalCostProducts).toFixed(2) + ' €'
      }
      if (totalRemise === 0) {
        document.getElementById('totalRemise').innerText = totalRemise + ' €'
      }
    },
    createEstimate () {
      this.$router.push('/App/Collection/Paiement/Devis')
    },
    createCollection () {
      if (localStorage.getItem('orderPrivilegia') === null) {
        this.errorMsg = 'Aucune ligne renseignée'
      } else {
        if (confirm('Valider mon encaissement - Fiche technique renseignée ?')) {
          if (localStorage.getItem('orderPrivilegiaSettings') !== null) {
          // Si modification d'un encaissement déjà enregistré
            const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
            const idToModify = JSON.parse(localStorage.getItem('orderPrivilegiaSettings'))[0].factureId
            const url = document.location.href
            const idToUse = url.substring(url.lastIndexOf('=') + 1)
            let mySelection = JSON.parse(localStorage.getItem('orderPrivilegia'))
            axios
              .put('https://privilegia.fr/api/factures/' + idToModify,
                { 'userId': idToUse,
                  'date': moment(Date.now()),
                  'number': 0,
                  'client': document.getElementById('idNameClient').textContent,
                  'lines': mySelection,
                  'reduction': parseInt(document.getElementById('totalReductionPourcent').outerText),
                  'amountreduction': parseFloat(document.getElementById('totalReductionCost').outerText),
                  'typeofpaiement': '-',
                  'paiementEspeces': 0,
                  'paiementCheques': 0,
                  'paiementCB': 0,
                  'paiementPaylib': 0,
                  'paiementPaypal': 0,
                  'totalprice': parseFloat(document.getElementById('totalCostsOfPanier').outerText),
                  'categoryOfInvoice': 1,
                  'technicalData': document.getElementById('idTechnicalData').value,
                  'dateBank': '-'
                }, {headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' }})
              .then((response) => {
                localStorage.removeItem('orderPrivilegia')
                localStorage.removeItem('orderPrivilegiaSettings')
              })
              .catch((error) => {
                console.log(error.response.data)
              })
          } else {
            // Si création d'un encaissement non enregistré au préalable
            const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
            const url = document.location.href
            const idToUse = url.substring(url.lastIndexOf('=') + 1)
            let mySelection = JSON.parse(localStorage.getItem('orderPrivilegia'))
            axios
              .post('https://privilegia.fr/api/factures',
                {
                  'userId': idToUse,
                  'date': moment(Date.now()),
                  'number': 0,
                  'client': document.getElementById('idNameClient').textContent,
                  'lines': mySelection,
                  'reduction': parseInt(document.getElementById('totalReductionPourcent').outerText),
                  'amountreduction': parseFloat(document.getElementById('totalReductionCost').outerText),
                  'typeofpaiement': '-',
                  'paiementEspeces': 0,
                  'paiementCheques': 0,
                  'paiementCB': 0,
                  'paiementPaylib': 0,
                  'paiementPaypal': 0,
                  'totalprice': parseFloat(document.getElementById('totalCostsOfPanier').outerText),
                  'categoryOfInvoice': 1,
                  'technicalData': document.getElementById('idTechnicalData').value,
                  'dateBank': '-'
                }, {headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' }})
              .then((response) => {
                localStorage.removeItem('orderPrivilegia')
                localStorage.removeItem('orderPrivilegiaSettings')
              })
          }
          this.$router.push('/App/Collection')
        }
      }
    },
    deleteCollection () {
      if (confirm('Supprimer mon encaissement ?')) {
        if (localStorage.getItem('orderPrivilegiaSettings') !== null) {
          const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
          const idToDelete = JSON.parse(localStorage.getItem('orderPrivilegiaSettings'))[0].factureId
          axios
            .delete('https://privilegia.fr/api/factures/' + idToDelete,
              { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
            .then((response) => {
              localStorage.removeItem('orderPrivilegia')
              localStorage.removeItem('orderPrivilegiaSettings')
            })
            .catch((error) => {
              console.log(error.response.data)
            })
        } else {
          localStorage.removeItem('orderPrivilegia')
          localStorage.removeItem('orderPrivilegiaSettings')
        }
        this.$router.push('/App/Collection')
      }
    }
  }
}
</script>
<style>
#appCollectionDivPrestations, #appCollectionDivProduits,#appCollectionDivReductions,#appCollectionDivWriting{display:none}
</style>



// WEBPACK FOOTER //
// src/components/Application/AppCollectionSlot.vue